import { render, staticRenderFns } from "./index.vue?vue&type=template&id=343099d8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Testimonial: require('/vercel/path0/components/testimonial.vue').default,Intermission: require('/vercel/path0/components/intermission.vue').default})
